import React from "react";

const ScreenLoading = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="33.5913"
        cy="37.8179"
        r="2.38916"
        transform="rotate(-180 33.5913 37.8179)"
        fill="#757575"
      />
      <circle
        cx="24.9917"
        cy="37.8179"
        r="2.38916"
        transform="rotate(-180 24.9917 37.8179)"
        fill="#454545"
      />
      <circle
        cx="16.3921"
        cy="37.8179"
        r="2.38916"
        transform="rotate(-180 16.3921 37.8179)"
        fill="#353535"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 18.6C17 17.7163 17.7163 17 18.6 17H31.4C32.2837 17 33 17.7163 33 18.6V26.5972C33 27.4809 32.2837 28.1972 31.4 28.1972H18.6C17.7163 28.1972 17 27.4809 17 26.5972V18.6ZM24.9997 30.9557C23.2179 30.9557 21.4173 31.3423 18.0326 32.1737L17.651 30.6198C21.0032 29.7965 22.992 29.3557 24.9997 29.3557C27.0074 29.3557 28.9962 29.7965 32.3484 30.62L31.9667 32.1738C28.5821 31.3424 26.7815 30.9557 24.9997 30.9557ZM19.4004 26.5977C20.2584 25.6402 22.6868 23.7768 25.5364 23.9822V26.259L29.8004 22.4293L25.5364 18.5997V21.4719C23.8117 21.9467 20.17 23.6366 19.4004 26.5977Z"
        fill="#7B7B7B"
      />
    </svg>
  );
};

export default ScreenLoading;
